/**
 * @generated SignedSource<<eff509d0a570d4f01f35cd7196ed0b55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplayBody$data = {
  readonly id: string;
  readonly info: any;
  readonly rootRubric?: {
    readonly " $fragmentSpreads": FragmentRefs<"ShowRubricKey">;
  };
  readonly " $fragmentType": "DisplayBody";
};
export type DisplayBody$key = {
  readonly " $data"?: DisplayBody$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplayBody">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "withRubric"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplayBody",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    },
    {
      "condition": "withRubric",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Rubric",
          "kind": "LinkedField",
          "name": "rootRubric",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ShowRubricKey"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "BodyItem",
  "abstractKey": null
};

(node as any).hash = "7b7dee1c02f23235baa2a77de00539db";

export default node;
